import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { DrawerFooter } from "@/components/ui/drawer";
import { AddFieldProps } from "./types";
import { ADD_CUSTOM_FIELD_TRANSLATION_KEY } from "./const";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { useFieldForm } from "./hooks/useFieldForm";
import { FieldFormContent } from "./components/FieldFormContent";

export const AddCustomField: React.FC<AddFieldProps> = ({
  onBack,
  onCancel,
  onSave,
  entityType = EntityType.DEAL
}) => {
  const { t } = useTranslation();

  const {
    formState,
    isFormValid,
    formRef,
    formSetValue,
    setFormSetValue,
    setShowHelpText,
    setShowInCreation,
    setIsRequired,
    handleFormValid,
    handleOptionsManagerChange,
    handleFormSubmit,
    handleSubmitButton,
    isSubmitting
  } = useFieldForm({
    fieldData: null,
    entityType: entityType,
    isEditMode: false
  });

  const handleSave = async () => {
    if (isSubmitting) {
      return;
    }

    try {
      const result = await handleFormSubmit();
      onSave(result);
    } catch (error) {
      console.error("Failed to create custom field:", error);
    }
  };

  return (
    <>
      <FieldFormContent
        formData={formState.formData}
        optionsManagerData={formState.optionsManagerData}
        fieldData={null}
        formSetValue={formSetValue}
        showHelpText={formState.showHelpText}
        showInCreation={formState.showInCreation}
        isRequired={formState.isRequired}
        onShowHelpTextChange={setShowHelpText}
        onShowInCreationChange={setShowInCreation}
        onRequiredChange={setIsRequired}
        onOptionsManagerChange={handleOptionsManagerChange}
        onFormValid={handleFormValid}
        onSubmit={handleSave}
        formRef={formRef}
        onSetValue={setFormSetValue}
        isEditMode={false}
        entityType={entityType}
      />

      <DrawerFooter>
        <div className="flex justify-between gap-2 w-full p-4 border-t-[0.5px] border-border-border1">
          {entityType !== EntityType.COMPANY &&
            entityType !== EntityType.PARTNER &&
            entityType !== EntityType.PARTNER_CONTACT && (
              <Button variant="tertiary" onClick={onBack} className="h-9">
                {t(`${ADD_CUSTOM_FIELD_TRANSLATION_KEY}.back`)}
              </Button>
            )}
          <div
            className={`flex gap-2 ${entityType === EntityType.COMPANY ? "ml-auto" : "ml-auto"}`}
          >
            <Button variant="secondaryNoBg" onClick={onCancel} className="h-9">
              {t("cancel")}
            </Button>
            <Button
              onClick={handleSubmitButton}
              disabled={!isFormValid || isSubmitting}
              className="h-9"
            >
              {t(`${ADD_CUSTOM_FIELD_TRANSLATION_KEY}.addField`)}
            </Button>
          </div>
        </div>
      </DrawerFooter>
    </>
  );
};
